import { parse as parseUrl } from 'url'

export const port = {
  get website() {
    return parseUrl(location.href).port
  },

  get api() {
    return location.protocol !== 'https:'
      ? '5003'
      : '5004'
  }
}

export const hostname = {
  website: {
    get development() {
      return location.hostname.concat(':', port.website)
    },

    get sandbox() {
      return 'sandbox.coteibem.com.br'
    },

    get production() {
      return 'coteibem.com.br'
    },

    get stage() {
      return 'stage.coteibem.com.br'
    },
  },

  api: {
    get development() {
      return location.hostname.concat(':', port.api)
    },

    get sandbox() {
      return 'apisandbox.coteibem.com.br'
    },

    get production() {
      return 'api.coteibem.com.br'
    },

    get stage() {
      return 'apistage.coteibem.com.br'
    },
  }
}

// Env Helpers
export const getEnvHostname = (env) => ({
  development: hostname.api.development,
  production: hostname.api.production,
  sandbox: hostname.api.sandbox,
  stage: hostname.api.stage,
}[env] || hostname.api.development)

export const getEnvHostnameWebsite= (env) => ({
  development: hostname.website.development,
  production: hostname.website.production,
  sandbox: hostname.website.sandbox,
  stage: hostname.website.stage,
}[env] || hostname.website.development)

export const getEnvGooglekey = (env) => ({
  development: 'AIzaSyBcb2thOr57IiihjGSFHFGxTLsW_vRjfuk',
  sandbox: 'AIzaSyDAApyZrGowBQRcdQWXvnO3IYbbzPZ3IHo',
  production: '#{GoogleMaps.Key}#',
}[env] || hostname.api.development)



export const getWebsiteUrl = (env = process.env.VM_ENV) => {
  const hostname = getEnvHostnameWebsite(env)

  return location.protocol.concat('//', hostname)
}

// CoteiBem API
export const getApiUrl = (apiVersion = 1, env = process.env.VM_ENV) => {
  const hostname = getEnvHostname(env)

  return location.protocol.concat('//', hostname, '/api/v', apiVersion.toString())
}

export const apiUrl = {
  get stable() {
    return getApiUrl()
  },

  get noVersion() {
    return getApiUrl(0).replace('/v0', '')
  }
}


// Websockets / SignalR
export const getRealtimeUrl = (env = process.env.VM_ENV) => {
  const hostname = getEnvHostname(env)

  return location.protocol.concat('//', hostname, '/realtime')
}

export const realtimeUrl = getRealtimeUrl()

export default {
  apiUrl,
  getApiUrl,
  hostname,
  realtimeUrl,
  getWebsiteUrl
}